import { useSelector } from "react-redux";
import { useMemo } from "react";
import styles from "./index.module.scss";

export default function Banner({ cityName, sectionId }) {
  const { catalogBanners } = useSelector((state) => state.content);
  const baner = useMemo(() => {
    return (
      Array.isArray(catalogBanners) &&
      catalogBanners.find((banner) => {
        if (
          banner.PROPERTY_SECTIONS_VALUE &&
          !banner.PROPERTY_SECTIONS_VALUE.includes(sectionId)
        ) {
          return false;
        }
        if (
          banner.PROPERTY_CITYS_VALUE &&
          banner.PROPERTY_CITYS_VALUE !== cityName
        ) {
          return false;
        }
        return true;
      })
    );
  }, [catalogBanners, cityName, sectionId]);

  return baner ? (
    <a href={baner.PROPERTY_LINK_VALUE} className={styles.Link}>
      <span dangerouslySetInnerHTML={{ __html: baner.PREVIEW_TEXT }}></span>
      <img className={styles.MobileBanner} src={baner.DETAIL_PICTURE} />
      <img className={styles.Banner} src={baner.PREVIEW_PICTURE} />
    </a>
  ) : null;
}
